<template lang="pug">
</template>
<script>
import {
  getTokenAndKey,
} from '@/utils';
import config from '@/const/config';
import {
  getRedirectUrl,
} from '@/api/vip';
import { ParamsUtil } from '../../../utils/params';

export default {
  data() {
    return {

    };
  },
  created() {
    this.getData();
  },
  methods: {
    async getData() {
      const {
        tabCode,
        adsource,
      } = ParamsUtil.getParams(window.location.href);
      const { token } = await getTokenAndKey();
      try {
        const res = await getRedirectUrl({
          token,
        });
        if (res.data) {
          const url = `https://m.hellobike.com/AppPlatformH5/${config.env !== 'pro' ? `${config.env === 'dev' ? 'fat' : config.env}/` : ''}latest/index.html#/vip/v3?isOpen=${res.data.isOpen}&tabCode=${tabCode || 'bike'}&adsource=${adsource}`;
          window.location.replace(url);
        }
      } catch (e) {
        // eslint-disable-next-line no-console
        console.log(e);
      }
    },
  },
};
</script>
